module.exports = "/_next/static/images/57571d7eb653bc482091eb09cd61d5f5-diana_1@3x.png";